// components/Shared/Pagination.jsx
import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pagesToShow = 3;
  const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  return (
    <div className="flex justify-center py-2">
      <div className="flex items-center gap-1.5">
        {/* Prev */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="w-10 h-10 rounded-xl flex items-center justify-center bg-[#111] border border-white/[0.06] text-gray-500 hover:text-white hover:border-white/[0.1] transition-colors duration-150 disabled:opacity-30 disabled:cursor-not-allowed active:scale-95"
        >
          <i className="fas fa-chevron-left text-xs"></i>
        </button>

        {startPage > 1 && (
          <span className="px-2 text-gray-600 text-sm">...</span>
        )}

        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-10 h-10 rounded-xl flex items-center justify-center text-sm font-bold transition-colors duration-150 active:scale-95 ${page === currentPage
                ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg shadow-purple-500/15'
                : 'bg-[#111] border border-white/[0.06] text-gray-500 hover:text-white hover:border-white/[0.1]'
              }`}
          >
            {page}
          </button>
        ))}

        {endPage < totalPages && (
          <span className="px-2 text-gray-600 text-sm">...</span>
        )}

        {totalPages > pagesToShow && endPage < totalPages && (
          <button
            onClick={() => onPageChange(totalPages)}
            className={`w-10 h-10 rounded-xl flex items-center justify-center text-sm font-bold transition-colors duration-150 active:scale-95 ${totalPages === currentPage
                ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg shadow-purple-500/15'
                : 'bg-[#111] border border-white/[0.06] text-gray-500 hover:text-white hover:border-white/[0.1]'
              }`}
          >
            {totalPages}
          </button>
        )}

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="w-10 h-10 rounded-xl flex items-center justify-center bg-[#111] border border-white/[0.06] text-gray-500 hover:text-white hover:border-white/[0.1] transition-colors duration-150 disabled:opacity-30 disabled:cursor-not-allowed active:scale-95"
        >
          <i className="fas fa-chevron-right text-xs"></i>
        </button>
      </div>
    </div>
  );
};

export default Pagination;